import { trackEvent } from '@rea-argonaut/analytics';

export default {
  trackEvent,
};
